import gql from 'graphql-tag'
import { ShippingMethodFragment } from '../fragments/ShippingMethodFragments'

export const shippingMethodsQuery = gql`
query shippingMethods($cartId: String, $postcode: Int) {
    shippingMethods(filters: { cart_id: $cartId, postcode: $postcode, only_available: true }) {
        ...ShippingMethodFragment
    }
}
${ShippingMethodFragment}
`
